var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedExclamatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4597 6.05027C10.8552 5.39821 11.5625 5 12.3251 5C13.0877 5 13.795 5.39821 14.1926 6.05373L20.3586 16.3474C20.7462 17.0188 20.7485 17.8454 20.3646 18.5189C19.9807 19.1924 19.2683 19.6116 18.4851 19.6202L6.15712 19.6201C5.38193 19.6116 4.66948 19.1924 4.28558 18.5189C3.90168 17.8454 3.904 17.0188 4.29757 16.3374L10.4597 6.05027ZM12.9469 6.80463C12.8151 6.58728 12.5793 6.45455 12.3251 6.45455C12.0709 6.45455 11.8351 6.58728 11.7054 6.80117L5.55128 17.0748C5.42206 17.2985 5.42129 17.5741 5.54926 17.7986C5.67722 18.0231 5.91471 18.1628 6.16511 18.1656L18.4771 18.1657C18.7355 18.1628 18.973 18.0231 19.101 17.7986C19.2289 17.5741 19.2282 17.2985 19.1048 17.0848L12.9469 6.80463ZM12.3251 9.43836C12.6933 9.43836 12.9976 9.71196 13.0457 10.0669L13.0524 10.1656V13.0747C13.0524 13.4764 12.7268 13.802 12.3251 13.802C11.9569 13.802 11.6526 13.5284 11.6045 13.1734L11.5978 13.0747V10.1656C11.5978 9.76397 11.9234 9.43836 12.3251 9.43836ZM13.0597 15.9838C13.0597 15.5822 12.734 15.2565 12.3324 15.2565L12.2264 15.2632C11.8714 15.3113 11.5978 15.6156 11.5978 15.9838C11.5978 16.3855 11.9234 16.7111 12.3324 16.7111L12.4311 16.7044C12.7861 16.6563 13.0597 16.352 13.0597 15.9838Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamatoryIcon);
export default __webpack_public_path__ + "static/media/red_exclamatory_icon.eb397553032af8ed1c3ff3f7db736ce3.svg";
export { ForwardRef as ReactComponent };